var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from 'react';
import Lottie from 'lottie-react'; // react-lottieのisPausedが動かないのでlottie-reactを採用
import { css } from 'aphrodite';
export const LottieIcon = ({ classObject, lottieDataUrl, lottieData, isPaused, loop = true, onComplete, loopMarkerOnComplete, }) => {
    const [animationData, setAnimationData] = React.useState(lottieData);
    const lottieRef = React.useRef(null);
    React.useEffect(() => {
        if (lottieData) {
            setAnimationData(lottieData);
            return;
        }
        if (!lottieDataUrl) {
            return;
        }
        const fetchAnimationData = () => __awaiter(void 0, void 0, void 0, function* () {
            const response = yield fetch(lottieDataUrl);
            const data = yield response.json();
            setAnimationData(data);
        });
        fetchAnimationData();
    }, [lottieDataUrl, lottieData]);
    React.useEffect(() => {
        if (!animationData || !lottieRef.current) {
            return;
        }
        if (isPaused) {
            lottieRef.current.goToAndStop(0, true);
            return;
        }
        lottieRef.current.play();
    }, [animationData, isPaused]);
    const handleComplete = () => {
        var _a;
        if (loopMarkerOnComplete && ((_a = lottieRef.current) === null || _a === void 0 ? void 0 : _a.animationItem)) {
            lottieRef.current.animationItem.setLoop(true);
            lottieRef.current.animationItem.goToAndPlay(loopMarkerOnComplete, true);
            return;
        }
        onComplete === null || onComplete === void 0 ? void 0 : onComplete();
    };
    if (!animationData)
        return null;
    return (React.createElement("div", { className: css(classObject) },
        React.createElement(Lottie, { lottieRef: lottieRef, animationData: animationData, loop: loop, autoplay: !isPaused, onComplete: handleComplete })));
};
